module.exports = __webpack_public_path__ + "7fc03569e7745663951bbc2eccbd14f0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/disease_large_red.png
 ** module id = 1055
 ** module chunks = 0
 **/